const pathDashboard = `dashboard`
const pathTicket = `ticket`
const pathCompany = `company`
const pathBranch = `branch`
const pathProduct = `product`
const pathProductCategory = `product-category`
const pathStaff = `staff`
const pathProfile = `profile`
const pathLogin = `login`
const pathPdpa = `terms-and-conditions`

export const routes = {
  dashboard: { id: pathDashboard, path: `/${pathDashboard}` },
  ticket: {
    id: pathTicket,
    path: `/${pathTicket}`,
    detail: { path: `/${pathTicket}/:id/detail` },
    receivedNotification: {
      path: `/${pathTicket}/received-notification/:messageId`,
    },
    assign: { path: `/${pathTicket}/:id/assign` },
    branch: {
      path: `/${pathTicket}/branch`,
      create: { path: `/${pathTicket}/branch/:id/new` },
    },
  },
  company: {
    id: pathCompany,
    path: `/${pathCompany}`,
    create: { path: `/${pathCompany}/new` },
    edit: { path: `/${pathCompany}/:id/edit` },
    detail: { path: `/${pathCompany}/:id/detail` },
  },
  branch: {
    id: pathBranch,
    path: `/${pathBranch}`,
    create: { path: `/${pathBranch}/new` },
    edit: { path: `/${pathBranch}/:id/edit` },
    detail: { path: `/${pathBranch}/:id/detail` },
    product: {
      path: `/${pathBranch}/:branchId/product`,
      create: { path: `/${pathBranch}/:branchId/product/new` },
      edit: { path: `/${pathBranch}/:branchId/product/:productId/edit` },
      detail: { path: `/${pathBranch}/:branchId/product/:productId/detail` },
    },
  },
  product: {
    id: pathProduct,
    path: `/${pathProduct}`,
    create: { path: `/${pathProduct}/new` },
    edit: { path: `/${pathProduct}/:id/edit` },
    detail: { path: `/${pathProduct}/:id/detail` },
  },
  productCategory: {
    id: pathProductCategory,
    path: `/${pathProductCategory}`,
    create: { path: `/${pathProductCategory}/new` },
    edit: { path: `/${pathProductCategory}/:id/edit` },
  },
  staff: {
    id: pathStaff,
    path: `/${pathStaff}`,
    edit: { path: `/${pathStaff}/:id/edit` },
  },
  profile: {
    id: pathProfile,
    edit: { path: `/${pathProfile}/edit` },
    /* TODO: change later if there is enough information. */
    setting: { path: '' },
  },
  login: { id: pathLogin, path: `/${pathLogin}` },
  error: {
    '504': '/504',
    '503': '/503',
    '502': '/502',
    '500': '/500',
    '404': '/404',
    '403': '/403',
  },
  pdpa: { id: pathPdpa, path: `/${pathPdpa}` },
} as const
